// removed by extract-text-webpack-plugin
module.exports = {"action-panel":"action-panel"};


//////////////////
// WEBPACK FOOTER
// ./components/article/_ArticleBox.scss
// module id = ./components/article/_ArticleBox.scss
// module chunks = 1